import { ChainID } from '@lay2/pw-core';
export class UPCKBConfig {
    upSnapshotUrl;
    ckbNodeUrl;
    ckbIndexerUrl;
    chainID;
    upLockCodeHash;
    constructor(upSnapshotUrl, // UniPass Snapshot server url
    ckbNodeUrl, // CKB node url
    ckbIndexerUrl, // CKB indexer url
    chainID, // CKB Chain ID
    upLockCodeHash // UniPass Asset Lock TypeID
    ) {
        this.upSnapshotUrl = upSnapshotUrl;
        this.ckbNodeUrl = ckbNodeUrl;
        this.ckbIndexerUrl = ckbIndexerUrl;
        this.chainID = chainID;
        this.upLockCodeHash = upLockCodeHash;
    }
}
const upConfig = new UPCKBConfig('', 'https://testnet.ckb.dev', 'https://testnet.ckb.dev/indexer', ChainID.ckb_testnet, '0xd3f6d12ac220b3f7e104f3869e72487f8940adb13a526a2abd775c2cd5040f77');
/**
 * set configuration for UPCKB
 * @param options UniPass CKB Config Options
 */
export function config(options) {
    upConfig.upSnapshotUrl = options?.upSnapshotUrl || upConfig.upSnapshotUrl;
    upConfig.chainID = options?.chainID || upConfig.chainID;
    upConfig.ckbNodeUrl = options?.ckbNodeUrl || upConfig.ckbNodeUrl;
    upConfig.ckbIndexerUrl = options?.ckbIndexerUrl || upConfig.ckbIndexerUrl;
    upConfig.upLockCodeHash = options?.upLockCodeHash || upConfig.upLockCodeHash;
}
export function getConfig() {
    return upConfig;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBRXhDLE1BQU0sT0FBTyxXQUFXO0lBRWI7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUxULFlBQ1MsYUFBcUIsRUFBRSw4QkFBOEI7SUFDckQsVUFBa0IsRUFBRSxlQUFlO0lBQ25DLGFBQXFCLEVBQUUsa0JBQWtCO0lBQ3pDLE9BQWdCLEVBQUUsZUFBZTtJQUNqQyxjQUFzQixDQUFDLDRCQUE0Qjs7UUFKbkQsa0JBQWEsR0FBYixhQUFhLENBQVE7UUFDckIsZUFBVSxHQUFWLFVBQVUsQ0FBUTtRQUNsQixrQkFBYSxHQUFiLGFBQWEsQ0FBUTtRQUNyQixZQUFPLEdBQVAsT0FBTyxDQUFTO1FBQ2hCLG1CQUFjLEdBQWQsY0FBYyxDQUFRO0lBQzVCLENBQUM7Q0FDTDtBQUVELE1BQU0sUUFBUSxHQUFnQixJQUFJLFdBQVcsQ0FDM0MsRUFBRSxFQUNGLHlCQUF5QixFQUN6QixpQ0FBaUMsRUFDakMsT0FBTyxDQUFDLFdBQVcsRUFDbkIsb0VBQW9FLENBQ3JFLENBQUM7QUFTRjs7O0dBR0c7QUFDSCxNQUFNLFVBQVUsTUFBTSxDQUFDLE9BQTJCO0lBQ2hELFFBQVEsQ0FBQyxhQUFhLEdBQUcsT0FBTyxFQUFFLGFBQWEsSUFBSSxRQUFRLENBQUMsYUFBYSxDQUFDO0lBQzFFLFFBQVEsQ0FBQyxPQUFPLEdBQUcsT0FBTyxFQUFFLE9BQU8sSUFBSSxRQUFRLENBQUMsT0FBTyxDQUFDO0lBQ3hELFFBQVEsQ0FBQyxVQUFVLEdBQUcsT0FBTyxFQUFFLFVBQVUsSUFBSSxRQUFRLENBQUMsVUFBVSxDQUFDO0lBQ2pFLFFBQVEsQ0FBQyxhQUFhLEdBQUcsT0FBTyxFQUFFLGFBQWEsSUFBSSxRQUFRLENBQUMsYUFBYSxDQUFDO0lBQzFFLFFBQVEsQ0FBQyxjQUFjLEdBQUcsT0FBTyxFQUFFLGNBQWMsSUFBSSxRQUFRLENBQUMsY0FBYyxDQUFDO0FBQy9FLENBQUM7QUFFRCxNQUFNLFVBQVUsU0FBUztJQUN2QixPQUFPLFFBQVEsQ0FBQztBQUNsQixDQUFDIn0=